import moment from "moment";
import { CANCELLATION_TIME } from "../../constants/AppConstant";
const cancellableLinkStatus = ["delivered", "not delivered", "unredeemed"];
const notResendableLinkStatus = [
  "cancelled",
  "redeemed",
  "canceled",
  "expired",
  "pending",
];

export const isRecordInDateRange = (record, isResend = false) => {
  const today = moment().toDate();
  let dateFinal = Math.abs(
    moment(record["generation_date"]).diff(today, "days")
  );
  if (
    moment(record["expiry_date"]).isSameOrAfter(today) &&
    (dateFinal <= CANCELLATION_TIME || isResend)
  ) {
    return true;
  } else {
    return false;
  }
};

const statusLabels = {
  2: "Scheduled",
  4: "Cancelled",
  0: "Cancelled",
};

export const isLinkCancellable = (linkData) => {
  let status = linkData?.status || linkData?.redemption_status;
  if (Number(status)) {
    status = statusLabels[status];
  }
  return (
    status &&
    cancellableLinkStatus.includes(status?.toLowerCase()) &&
    isRecordInDateRange(linkData)
  );
};

export const isLinkResendable = (linkData, isXoxoLink = false) => {
  let status = linkData?.status || linkData?.redemption_status || linkData?.delivery_status;
  if (Number(status)) {
    status = statusLabels[status];
  }
  return (
    status &&
    !notResendableLinkStatus.includes(status?.toLowerCase()) &&
    (isXoxoLink || isRecordInDateRange(linkData, true))
  );
};

export const downloadReportFromURL = (document, awsUrl) => {
  const link = document.createElement("a");
  link.href = awsUrl;
  link.setAttribute("download", true);

  // Append to html link element page
  document.body.appendChild(link);

  // Start download
  link.click();

  // Clean up and remove the link
  link.parentNode.removeChild(link);
};

export const downloadReportFromPrivateURL = (document, url, response) => {
  var link = document.createElement("a");
  link.download = response && response.filename;
  link.href = url;
  link.click();
};
